import topBreakoutProxy from '../../../proxies/market/top-mover/TopBreakout';
import topGainers from '../../../proxies/market/top-mover/TopGainersProxy';
import topLosers from '../../../proxies/market/top-mover/TopLosersProxy';
import topNewHigh from '../../../proxies/market/top-mover/TopNewHighProxy';
import topNewLow from '../../../proxies/market/top-mover/TopNewLowProxy';
import topForeignTrading from '../../../proxies/market/top-mover/TopForeignTrading';
import topValueProxy from '../../../proxies/market/top-mover/TopValueProxy';
import overviewProxy from '../../../proxies/market/top-mover/TopVolumeProxy';
import topMoverChartProxy from '../../../proxies/market/top-mover/TopMoverChartProxy';
import topDownloadProxy from '../../../proxies/market/top-mover/TopDownload';
import ServiceBase from '../../ServiceBase';
import { ChanelConfig } from './../../../../configs/GlobalConfig';

class TopVolumeService extends ServiceBase {
  getDataTopVolumeOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'TopVolumeService.getDataTopVolumeOverview',
          params,
        )(() => overviewProxy.getTopVolume(params)),
    );
  }

  fetchListTopBreakoutData(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopBreakout', params)(
          () => topBreakoutProxy.getTopBreakout(params),
        ),
    );
  }

  getDataTopValueOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopValue', params)(() =>
          topValueProxy.getTopValue(params),
        ),
    );
  }

  getDataTopGainersOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopGainers', params)(
          () => topGainers.getTopGainers(params),
        ),
    );
  }

  getDataTopLosersOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopLosers', params)(() =>
          topLosers.getTopLosers(params),
        ),
    );
  }

  getDataTopNewHighOverview(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopNewHigh', params)(
          () => topNewHigh.getTopNewHigh(params, source),
        ),
    );
  }

  getDataTopNewLowOverview(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TopVolumeService.getDataTopNewLow', params)(() =>
          topNewLow.getTopNewLow(params),
        ),
    );
  }

  getDataTopForeignTrading(params) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache(
          'TopVolumeService.getDataTopForeignTrading',
          params,
        )(() => topForeignTrading.getTopForeignTrading(params)),
    );
  }

  getTopVolumeChartImage(params) {
    return this.applyMemoryCache(
      'TopVolumeService.getTopVolumeChartImage',
      params,
    )(() => topMoverChartProxy.getTopVolumeChartImage(params));
  }

  downloadTopBreakout(params) {
    return this.applyMemoryCache(
      'TopVolumeService.DownloadTopBreakout',
      params,
    )(() => topDownloadProxy.downloadTopBreakout(params));
  }

  downloadTopGainer(params) {
    return this.applyMemoryCache('TopVolumeService.downloadTopGainer', params)(
      () => topDownloadProxy.downloadTopGainer(params),
    );
  }

  downloadTopForeignTrading(params) {
    return this.applyMemoryCache(
      'TopVolumeService.DownloadTopForeignTradding',
      params,
    )(() => topDownloadProxy.downloadTopForeignTrading(params));
  }

  downloadTopLoser(params) {
    return this.applyMemoryCache('TopVolumeService.downloadTopLoser', params)(
      () => topDownloadProxy.downloadTopLoser(params),
    );
  }

  downloadTopNewLow(params) {
    return this.applyMemoryCache('TopVolumeService.DownloadTopNewLow', params)(
      () => topDownloadProxy.downloadTopNewLow(params),
    );
  }

  downloadTopNewHigh(params) {
    return this.applyMemoryCache('TopVolumeService.downloadTopNewHigh', params)(
      () => topDownloadProxy.downloadTopNewHigh(params),
    );
  }

  downloadTopVolume(params) {
    return this.applyMemoryCache('TopVolumeService.downloadTopVolume', params)(
      () => topDownloadProxy.downloadTopVolume(params),
    );
  }

  downloadTopValue(params) {
    return this.applyMemoryCache('TopVolumeService.downloadTopValue', params)(
      () => topDownloadProxy.downloadTopValue(params),
    );
  }
}

const topVolumeService = new TopVolumeService();
export default topVolumeService;
